module.exports = __webpack_public_path__ + "img/scan.50d13223.svg";